import { Flex } from "@chakra-ui/react";
import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <Flex as="footer" className="footer" justifyContent="space-between">
      <div className="text-muted">&nbsp;&copy;&nbsp; Arup 2023 All rights reserved</div>
      <div className="text-muted">Protected under GDPR</div>
    </Flex>
  );
};

export default Footer;
